export const getSuccessErrorBackground = (value: boolean): { [key: string]: string } => {
	return {
		backgroundColor: value ? 'lightgreen' : 'lightcoral',
		height: '25px',
		width: '90%',
		textAlign: 'center'
	};
};
